import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-union-icon',
  templateUrl: './design-union.component.html'
})
export class DesignUnionComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
